import React from 'react'
import { BracketContainer } from '../../Components/Bracket/bracketContainer'
import { AdUnit } from '../../Components/Ads/AdUnit'

const Playoffs: React.FC<React.PropsWithChildren<unknown>> = () => {

  return (
    <>
      <AdUnit bannerType="bannerMain" aria-label="Playoffs page ad main" />
      <BracketContainer />
      <AdUnit bannerType="bannerSecond" aria-label="Playoffs page ad second" />
    </>
  )
}

export default Playoffs
